
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary/web-analytics/[fname]",
      function () {
        return require("private-next-pages/glossary/web-analytics/[fname].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary/web-analytics/[fname]"])
      });
    }
  